import { ReactNode } from 'react'
import TSConstants from '../../../utils/TSConstants'
import LCLPSkin from './lclp'

export interface QuizzSkinI {
  skin: () => number
  replaceHomeLogo: () => ReactNode
  homeHeaderDecoration: () => ReactNode
  appendToBody: (step: number) => ReactNode
}

export default class QuizzNormalSkin implements QuizzSkinI {
  homeHeaderDecoration(): React.ReactNode {
    return null
  }

  replaceHomeLogo(): React.ReactNode {
    return null
  }

  skin(): number {
    return 0
  }

  appendToBody(step: number) {
    return null
  }
}

export function getSkin(skin?: number) {
  switch (skin) {
    case TSConstants.QUIZZ_SKIN_LEADER_PRICE_ANNIVERSARY:
      return new LCLPSkin()
  }

  return new QuizzNormalSkin()
}
